export default "__VITE_ASSET__CJEq4MEe__"